var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPdLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 538.67 76.18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "PocketDoctor") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_1-2",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M19,57.17V78.4H6.41V16.78H26.2q21.19,0,21.19,19.64,0,9.28-6.08,15T25.06,57.17Zm0-29.73V46.65h5q10.08,0,10.09-9.71,0-9.51-10.09-9.5Z",
    transform: "translate(-6.41 -3.29)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M71.13,79.47q-10,0-15.74-6.16T49.67,56.57q0-10.91,5.94-17.08t16.07-6.16q10,0,15.64,6.16T93,55.8q0,11-5.85,17.32T71.13,79.47Zm.31-35.75A8,8,0,0,0,64.64,47c-1.62,2.21-2.42,5.33-2.42,9.37q0,12.67,9.3,12.68,8.88,0,8.88-13Q80.4,43.72,71.44,43.72Z",
    transform: "translate(-6.41 -3.29)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M131.39,76.81q-4.18,2.67-12.08,2.66-9.23,0-14.94-6.14t-5.7-15.86q0-11.2,6.11-17.68t16.37-6.46q7.08,0,10.24,2.06V46.9a13.27,13.27,0,0,0-8.64-3.18,10.81,10.81,0,0,0-8.42,3.42q-3.12,3.42-3.11,9.43,0,5.85,3,9.18a10.38,10.38,0,0,0,8.17,3.33,15.29,15.29,0,0,0,9-3.18Z",
    transform: "translate(-6.41 -3.29)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M179.64,78.4H164.82L152,56.57h-.15V78.4H139.52V13.26h12.36V54.72H152L164,34.4h14.66L164.27,55.07Z",
    transform: "translate(-6.41 -3.29)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M219.17,60.27H193.05q.63,9.58,11,9.58a20,20,0,0,0,11.61-3.44v9.8q-5.55,3.27-14.42,3.26-9.71,0-15.06-5.9t-5.35-16.48q0-11,5.78-17.36a18.44,18.44,0,0,1,14.24-6.4q8.74,0,13.54,5.71t4.79,15.51Zm-11.45-8.34q0-9.45-7-9.45a6.41,6.41,0,0,0-5.14,2.71A12.84,12.84,0,0,0,193,51.93Z",
    transform: "translate(-6.41 -3.29)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M250.77,77.88q-2.73,1.59-8.25,1.59-13.05,0-13.06-14.91V44.41H223v-10h6.49V24.9L241.78,21V34.4h9v10h-9V62.2c0,4.58,1.66,6.88,5,6.88a7.8,7.8,0,0,0,4-1.25Z",
    transform: "translate(-6.41 -3.29)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M259,78.4V16.78h19.87q29.87,0,29.87,30,0,14.38-8.15,23T278.84,78.4ZM271.6,28.08V67.14h6.26q8.2,0,12.88-5.41T295.42,47q0-8.81-4.64-13.86t-13-5.05Z",
    transform: "translate(-6.41 -3.29)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M335.94,79.47q-10,0-15.74-6.16t-5.72-16.74q0-10.91,5.94-17.08t16.07-6.16q10,0,15.64,6.16T357.8,55.8q0,11-5.85,17.32T335.94,79.47Zm.31-35.75a8,8,0,0,0-6.8,3.31c-1.62,2.21-2.42,5.33-2.42,9.37q0,12.67,9.3,12.68,8.88,0,8.88-13Q345.21,43.72,336.25,43.72Z",
    transform: "translate(-6.41 -3.29)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M396.2,76.81q-4.18,2.67-12.08,2.66-9.22,0-14.94-6.14t-5.7-15.86q0-11.2,6.11-17.68T386,33.33q7.08,0,10.24,2.06V46.9a13.27,13.27,0,0,0-8.64-3.18,10.81,10.81,0,0,0-8.42,3.42Q376,50.56,376,56.57q0,5.85,3,9.18a10.38,10.38,0,0,0,8.17,3.33,15.29,15.29,0,0,0,9-3.18Z",
    transform: "translate(-6.41 -3.29)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M428.53,77.88q-2.73,1.59-8.25,1.59-13,0-13.06-14.91V44.41h-6.49v-10h6.49V24.9L419.54,21V34.4h9v10h-9V62.2c0,4.58,1.66,6.88,5,6.88a7.8,7.8,0,0,0,4-1.25Z",
    transform: "translate(-6.41 -3.29)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M454.29,79.47q-10,0-15.74-6.16t-5.72-16.74q0-10.91,5.94-17.08t16.07-6.16q10,0,15.64,6.16t5.67,16.31q0,11-5.85,17.32T454.29,79.47Zm.31-35.75A8,8,0,0,0,447.8,47c-1.62,2.21-2.42,5.33-2.42,9.37q0,12.67,9.3,12.68,8.88,0,8.88-13Q463.56,43.72,454.6,43.72Z",
    transform: "translate(-6.41 -3.29)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M510.34,46.65a9.91,9.91,0,0,0-5.2-1.34,7.29,7.29,0,0,0-6.3,3.25q-2.26,3.24-2.26,8.83v21H484.22v-44h12.36v8.16h.15q2.94-8.93,10.56-8.93a7.4,7.4,0,0,1,3,.51Z",
    transform: "translate(-8.01 -3.29)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M525.32,5.33h-5.65V18.87h-2.48V5.33h-5.75v-2h13.88Z",
    transform: "translate(-6.41 -3.29)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M542.65,18.87,542.36,8l-5.29,8.69h-1.6L530.32,8,530,18.87h-2.44l.63-15.58h1.6L536.26,14l6.65-10.68h1.58l.6,15.58Z",
    transform: "translate(-6.41 -3.29)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdLogo);
export default __webpack_public_path__ + "static/media/pd-logo.968634b8b055cdca54affeb649aa647a.svg";
export { ForwardRef as ReactComponent };